import { useRef } from 'react'
import debounce from '@/utils/debounce/debounce'
import {
  CRM_REALTIME_CHAT_REFETCH_DEBOUNCE_MS,
  useRefetchOnBrowserTabVisible,
} from '@pages/Admin/CRM/utils/crmRealtimeWebSocket'

type UseCrmIntegrationBrowserTabVisibleMessagesRefetchParams = {
  enabled?: boolean
  loadMessages: (loadOptions?: { silent?: boolean }) => Promise<void>
}

export const useCrmIntegrationBrowserTabVisibleMessagesRefetch = ({
  enabled = true,
  loadMessages,
}: UseCrmIntegrationBrowserTabVisibleMessagesRefetchParams): void => {
  const loadMessagesRef = useRef(loadMessages)
  loadMessagesRef.current = loadMessages

  const debouncedSilentLoadRef = useRef(
    debounce(() => {
      void loadMessagesRef.current({ silent: true })
    }, CRM_REALTIME_CHAT_REFETCH_DEBOUNCE_MS),
  )

  useRefetchOnBrowserTabVisible(() => {
    debouncedSilentLoadRef.current()
  }, enabled)
}
